import icon from 'vue-svgicon';

icon.register({
    'bold/car-retro-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M23.25 15.875a.079.079 0 0 1-.079-.071 62.078 62.078 0 0 0-.458-3.225 9.479 9.479 0 0 0-9.375-7.954c-6.763 0-9.116 5.8-9.533 6.872a.249.249 0 0 1-.209.158C0 12 0 15.21 0 16.625a.75.75 0 0 0 .75.75h.76a.25.25 0 0 0 .249-.231 3 3 0 0 1 5.982 0 .251.251 0 0 0 .249.231h7.52a.25.25 0 0 0 .249-.231 3 3 0 0 1 5.982 0 .251.251 0 0 0 .249.231h1.26a.75.75 0 0 0 0-1.5zm-10.5-5.25a.249.249 0 0 1-.25.25H7.581a.5.5 0 0 1-.431-.754 6.11 6.11 0 0 1 5.34-3.249.256.256 0 0 1 .184.07.249.249 0 0 1 .076.18zm6.091-.008a.5.5 0 0 1-.437.258H15a.25.25 0 0 1-.25-.25v-3.3a.252.252 0 0 1 .1-.2.249.249 0 0 1 .221-.039 7.044 7.044 0 0 1 3.754 3.023.5.5 0 0 1 .016.508z"/><circle pid="1" cx="4.75" cy="17.375" r="2"/><circle pid="2" cx="18.75" cy="17.375" r="2"/>`,
    },
});
